import script from "./HeroDasboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroDasboard.vue?vue&type=script&setup=true&lang=js"

import "./HeroDasboard.vue?vue&type=style&index=0&id=4c7efc59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7efc59"]])

export default __exports__